import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import "../Print.css";

type OrderDataProps = {
  orderData: {
    net_sales: number;
    sales_vat: number;
    gross_sales: number;
    sales_discount: number;
  };
  source: string;
};

export const OrderSummary: FunctionComponent<OrderDataProps> = ({
  orderData,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Order Summary</Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Gross Advance
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {orderData?.gross_sales ? orderData.gross_sales : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Discounts
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {orderData?.sales_discount
                    ? orderData.sales_discount
                    : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Vat Collected
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {orderData?.sales_vat ? orderData.sales_vat : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="left"
                >
                  Net Advance
                </TableCell>
                <TableCell className={classes.headCell} align="right">
                  {orderData?.net_sales ? orderData.net_sales : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
